import office from 'src/services/office';
import { runShortAction } from 'src/services/utils';
import { CellAddressPickerValue } from '../types';

export function useCellAddressSelection(
  disableSingleCell: boolean,
  onChange: (value: CellAddressPickerValue | null, valid: boolean) => void,
  buildInputValue: (value: CellAddressPickerValue | null) => string,
  setInputValue: React.Dispatch<React.SetStateAction<string>>,
  setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>,
) {
  const handleTargetClick = (): void => {
    runShortAction(async () => {
      const selectedRanges = await office.getSelectedRanges();
      let address = selectedRanges.addresses[0];

      if (!disableSingleCell) {
        address = address.getFirstCell();
      }

      const newValue: CellAddressPickerValue = {
        worksheetId: selectedRanges.worksheetId,
        address: address.shortAddress,
        customRange: '',
      };

      onChange(newValue, true);
      setInputValue(buildInputValue(newValue));
      setErrorMessage(null);
    });
  };

  return { handleTargetClick };
}
